import controller from './my-account.controller';

export default {
  bindings: {
    packet: '<'
  },
  controller,
  template: require('./my-account.html')
};



// WEBPACK FOOTER //
// src/app/my-account/my-account.component.ts